import { createReducer, on } from "@ngrx/store";
import { DocViewerState } from "@store/doc-viewer/doc-viewer.state";
import { documentListActions } from "@store/doc-viewer/document-list/document-list.actions";
import { cloneDeep } from 'lodash-es';

export const documentListReducer = createReducer<DocViewerState['documentList']>(
	{
		docList: [],
		isExpandedResults: false
	},
	on(documentListActions.listUpdated, (_state, { newDocumentList, isExpandedResults }) => {
		const clone = cloneDeep(_state);
		clone.docList = newDocumentList;
		clone.isExpandedResults = isExpandedResults;
		return clone;
	}),
);
